'use client';

import { useRouter, useSearchParams } from 'next/navigation';

interface FilterSidebarProps {
  brands: string[];
}

const COLORS = ['Black', 'Cyan', 'Magenta', 'Yellow', 'Other'] as const;
const AVAILABILITY = [
  { v: '', label: 'All' },
  { v: 'in', label: 'In' },
  { v: 'low', label: 'Low' },
  { v: 'out', label: 'Out' },
];

export function FilterSidebar({ brands }: FilterSidebarProps) {
  const router = useRouter();
  const sp = useSearchParams();

  function setParam(key: string, value: string) {
    const params = new URLSearchParams(sp.toString());
    if (value) params.set(key, value);
    else params.delete(key);
    params.delete('offset');
    router.push(`?${params.toString()}`);
  }

  const currentBrand = sp.get('brand') ?? '';
  const currentColor = sp.get('color') ?? '';
  const currentAvail = sp.get('avail') ?? '';

  return (
    <aside className="flex flex-col gap-5 rounded-lg border border-neutral-200 bg-white p-4 text-sm shadow-sm">
      <section>
        <h3 className="mb-2 text-[10px] font-bold tracking-widest text-neutral-500 uppercase">
          Brand
        </h3>
        <select
          value={currentBrand}
          onChange={(e) => setParam('brand', e.target.value)}
          className="w-full rounded border border-neutral-300 bg-white px-2 py-1.5 text-sm focus:border-amber-500 focus:outline-none"
        >
          <option value="">All brands</option>
          {brands.map((b) => (
            <option key={b} value={b}>
              {b}
            </option>
          ))}
        </select>
      </section>

      <section>
        <h3 className="mb-2 text-[10px] font-bold tracking-widest text-neutral-500 uppercase">
          Color
        </h3>
        <select
          value={currentColor}
          onChange={(e) => setParam('color', e.target.value)}
          className="w-full rounded border border-neutral-300 bg-white px-2 py-1.5 text-sm focus:border-amber-500 focus:outline-none"
        >
          <option value="">Any</option>
          {COLORS.map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </select>
      </section>

      <section>
        <h3 className="mb-2 text-[10px] font-bold tracking-widest text-neutral-500 uppercase">
          Availability
        </h3>
        <div className="grid grid-cols-4 gap-1">
          {AVAILABILITY.map((a) => {
            const active = currentAvail === a.v;
            return (
              <button
                key={a.v}
                type="button"
                onClick={() => setParam('avail', a.v)}
                className={
                  active
                    ? 'rounded border border-amber-500 bg-amber-500 px-2 py-1 text-xs font-semibold text-white'
                    : 'rounded border border-neutral-300 bg-white px-2 py-1 text-xs font-medium text-neutral-700 hover:border-amber-500'
                }
              >
                {a.label}
              </button>
            );
          })}
        </div>
      </section>
    </aside>
  );
}
